import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import { travelTypes, } from 'core'

import './styles.css'

class ToFromDisplay extends Component {
  static propTypes = {
    type: PropTypes.oneOf([
      'flight',
      'boat',
      'bus',
      'car',
      'train',
    ]).isRequired,
    departFrom: PropTypes.string.isRequired,
    departureTime: PropTypes.string.isRequired,
    arriveAt: PropTypes.string.isRequired,
    arrivalTime: PropTypes.string.isRequired,
    terminal: PropTypes.string,
    flightNumber: PropTypes.string,
  }

  static defaultProps = {
    terminal: undefined,
    flightNumber: undefined,
  }

  render() {
    const {
      type,
      departFrom,
      terminal,
      departureTime,
      flightNumber,
      arriveAt,
      arrivalTime,
    } = this.props

    const TravelTypeIcon = travelTypes[type].icon
    const travelTypeIconDisplay = <TravelTypeIcon fill="white" width={32} />

    // ensure that icons are left-to-right displayed
    // (by reverting icons that are left-to-right)
    const revert = !!(travelTypes[type].direction === 'right-to-left')
    const revertIconClass = revert ? 'revert-icon' : ''

    return (
      <div className="to-from-container">
        <div className={`item type ${revertIconClass}`}>
          {travelTypeIconDisplay}
          <div className="item">
            {departureTime}
          </div>
          <div className="item">
            {arrivalTime}
          </div>
        </div>
        <div className="item">
          <div className="item">
            {departFrom}
          </div>
          <div className="item">
            {terminal}
          </div>
        </div>
        <div className="item">
          {flightNumber}
        </div>
        <div className="item">
          {arriveAt}
        </div>
      </div>
    )
  }
}

export default ToFromDisplay



// WEBPACK FOOTER //
// ./src/components/ToFromDisplay/index.js